
import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Сгущались сумерки.
      </p>
      
      <p class="mb-3">
        Головы склонились друг к другу, разговоры становились всё тише. 
        Но тем ярче разгоралась в них неутолимая пылающая ненависть.
      </p>
      
      <p class="mb-3">
        - Его надо убить. 
        Нельзя, чтобы он жил. 
        Нельзя, чтобы над нами властвовал человек, который лучше нас.
      </p>
      
      <p class="mb-3">
        - Да, это невыносимо. 
        Смотреть и знать, что он в самом деле лучше меня: знает больше, быстрее оценивает обстановку, быстрее принимает решения, 
        и они все ведут к победам! 
        ЕГО победам!
      </p>
      
      <p class="mb-3">
        - А мы тут ни при чём. 
        Мы бы так не сделали, и поэтому мы не чувствуем себя победителями, хотя и служим ему. 
        Он – не наш, и мы – не с ним. 
        Его победы – не наши победы.
      </p>
      
      <p class="mb-3">
        - Он постоянно оскорбляет меня самой жизнью своей. 
        Почему ему всё удаётся? 
        Почему его любят, а меня нет? 
        Он даже врагов прощает, и они переходят к нему. 
        А мои враги меня ненавидят…
      </p>
      
      <p class="mb-3">
        - Да, да! Вот этого я ему никогда не прощу. 
        Я умею воевать, я знаю ненависть к врагу, и эта ненависть ведёт меня в битву. 
        Я никогда никого не жалел, и враги не жалели меня. 
        А он – прощает! 
        И побеждает больше, чем я! 
        Ненавижу!
      </p>
      
      <p class="mb-3">
        - А я его ненавижу за то, что он может больше, чем другие люди, в обычной жизни. 
        Он одновременно читает, пишет и говорит; он меняет календарь; разве это доступно простому человеку? 
        Это несправедливо!
      </p>
      
      <p class="mb-3">
        - Вот-вот, он может, а я нет! 
        Почему он может больше меня? 
        Я не хочу, чтобы кто-то был лучше, чем я, чтобы умел и мог больше! 
        И если такой есть – пусть его не будет! 
        Пусть не будет никого лучше, чем я!
      </p>
      
      <p class="mb-3">
        - Да, вы все правы. 
        Самое невыносимое – терпеть, когда нами управляет человек по праву, по справедливости, и мы не можем утешать себя рассуждениями, 
        что и на Солнце есть пятна, и что он так же жалок, мал и слаб, как мы. 
        Да, мы ничтожны и слабы, но нас больше, мы можем накинуться на него все вместе. 
        И пусть он умрёт!
      </p>
      
      <p class="mb-5">
        - (Все вместе): Он должен умереть!
      </p>
    
      <p class="mb-3">
        Сгущались сумерки.
      </p>
      
      <p class="mb-3">
        Стоял вечер 14 марта 44 г. до н.э.
      </p>
    

    </div>
    `
  )
}

const itemName = {
  rus: `Весенние грёзы`
}


const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;